import {
  type PricingServiceCustomerPlanPrice,
  type PricingServicePricedContainer,
} from '@hungryroot/rest';

export function getContainerIdToContainer(
  plansPriceData: PricingServiceCustomerPlanPrice
) {
  return plansPriceData.priced_containers.reduce(
    (acc, container) => {
      const { container_id } = container;
      acc[container_id] = container;
      return acc;
    },
    {} as Record<number, PricingServicePricedContainer>
  );
}
